import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'schoolYearFormat',
})
export class SchoolYearFormatPipe implements PipeTransform {
  transform(schoolYear: number | null | undefined): string {
    if (!schoolYear) return '';
    
    return `${schoolYear} - ${schoolYear + 1}`;
  }
}